import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';

import axios from 'axios';

export default class Locator extends Component {
  static propTypes = {
    googleMapsObject: PropTypes.object.isRequired,
    googleMapsLoaded: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      latitude: "41.7319713",
      longitude: "-77.6506319",
      geoAllowed: false,
      storeLocations: [],
      storeCollapseOpenArray: [],
      distanceObjectArray: [{StoreID: "", Distance: ""}],
      listBtnSelected: true,
      mapBtnSelected: false,
      accuracy: "",
      mapReadyToBeSet: false
    };
  }

  componentDidMount() {
    try { this.getStoreLocations(); } catch(err) { console.log(err); }
  }

  getStoreLocations = () => {
    axios.get('https://s3.amazonaws.com/primitivescandlesstorage/locations/StoreLocations.json')
      .then(response => {
        this.setState({
          storeLocations: response.data
        }, () => { this.getLocation(); } );
        
      })
      .catch(error => {
        console.log('Error fetching and parsing data', error);
      });
  }

  getLocation = () => { if(navigator.geolocation) { navigator.geolocation.getCurrentPosition(this.setLocationStateSuccess, this.setLocationStateError); } }

  setLocationStateSuccess = (position) => { 
    this.setState({ geoAllowed: true, latitude: position.coords.latitude, longitude: position.coords.longitude, accuracy: position.coords.accuracy},
     () => this.setDistanceArray() );
  }
  setLocationStateError = (err) => {
    switch(err.code) {
        case err.PERMISSION_DENIED:
            console.log("User denied the request for Geolocation.");
            break;
        case err.POSITION_UNAVAILABLE:
            console.log("Location information is unavailable.");
            break;
        case err.TIMEOUT:
            console.log("The request to get user location timed out.");
            break;
        case err.UNKNOWN_ERROR:
            console.log("An unknown error occurred.");
            break;
    }
  }

  setDistanceArray = () => {
      const service = new this.props.googleMapsObject.DistanceMatrixService();

      let originCoordsCurrent = (this.state.latitude + "," + this.state.longitude);
      let destinationCoordsArray = [];
      
      this.state.storeLocations.map((store, index) => {
        destinationCoordsArray.push(store.coords)
      });

      service.getDistanceMatrix(
      {
        origins: [originCoordsCurrent],
        destinations: destinationCoordsArray,
        travelMode: this.props.googleMapsObject.TravelMode.DRIVING,
        unitSystem: this.props.googleMapsObject.UnitSystem.IMPERIAL,
        avoidHighways: false,
        avoidTolls: false
      }, (response, status) => {
        if (status != this.props.googleMapsObject.DistanceMatrixStatus.OK) {
          console.log(`Fetching DistanceMatrix has not-ok status. Status is: ${status}`);
        }
        else {
          let distanceObjectArrayCopy = this.state.distanceObjectArray;

          this.state.storeLocations.map((store, index) => {
            let origin = response.originAddresses[0];
            let destination = response.destinationAddresses[index];

            if (response.rows[0].elements[index].status === "ZERO_RESULTS") {
              console.log("No routes found from your current position to the destination.");
            } 
            else {
              let distance = response.rows[0].elements[index].distance;
              let distance_value = distance.value;
              let distance_text = distance.text;
              let miles = distance_text.substring(0, distance_text.length - 3);
              //console.log("It is " + miles + " miles from " + origin + " to " + destination);

              //const distanceObjectArrayCopy = this.state.distanceObjectArray;
              const distanceObject = {StoreID: store.storeID, Distance: miles};
              distanceObjectArrayCopy[index] = distanceObject;

              if(index == this.state.storeLocations.length - 1) 
              {
                this.setState({
                  distanceObjectArray: distanceObjectArrayCopy
                }, () => this.sortLocationsAndDistances() );
              }
            }
          });
        }
      });
  }

  sortLocationsAndDistances = () => {
    // Sort by default: Distance ascending
    // Must be length of the store locations array to signify the state distance array being fully filled with distances.
    if(this.state.distanceObjectArray.length == this.state.storeLocations.length) {
      // Create empty arrays: storeIDOrderArray, newStoreLocationsArray, newDistanceObjectArray
      let storeIDOrderArray = [];
      let newStoreLocationsArray = [];
      let newDistanceObjectArray = [];

      // Sort distance asc 
      let sortedDistanceObjectArray = this.state.distanceObjectArray;
      
      sortedDistanceObjectArray.sort((a, b) => {
        return parseFloat(a.Distance) - parseFloat(b.Distance);
      });

      // Push the order of storeIDs to storeIDOrderArray
      for(var i=0; i<sortedDistanceObjectArray.length; i++) {
        // If object is defined
        if(sortedDistanceObjectArray[i]) {
          storeIDOrderArray.push(sortedDistanceObjectArray[i].StoreID);
        }
      }

      // Sort new arrays that will update state and props arrays
      for(var i=0; i<storeIDOrderArray.length; i++) {
        // Set newStoreLocationsArray
        var storeToPush = this.state.storeLocations.find(obj => obj.storeID == storeIDOrderArray[i]);
        // If object is defined
        if(storeToPush)
        {
          //console.log(storeToPush);
          newStoreLocationsArray.push(storeToPush);
        }
        // Set newDistanceObjectArray
        var distanceObjectToPush = sortedDistanceObjectArray.find(obj => obj.StoreID == storeIDOrderArray[i]);
        // If object is defined
        if(distanceObjectToPush) 
        {
          //console.log(distanceObjectToPush);
          newDistanceObjectArray.push(distanceObjectToPush);
        }
      }

      // Update props and state arrays
      this.setState({
        storeLocations: newStoreLocationsArray,
        distanceObjectArray: newDistanceObjectArray
      }, () => this.createStoreCollapseArray() );
    }
  }

  createStoreCollapseArray = () => {
    let storeCollapseOpenArray = [];

    for(var i=0; i<this.state.storeLocations.length; i++) 
    {
      if(i==0) {
        storeCollapseOpenArray.push(true);
      }
      else {
        storeCollapseOpenArray.push(false);
      }
    }

    this.setState({
      storeCollapseOpenArray: storeCollapseOpenArray
    }, () => { this.setMap(); } );
  }

  storeCollapseToggle = (index) => {
    var storeCollapseOpenArray = this.state.storeCollapseOpenArray;

    // If the element is selected and clicked, close it.
    var currentlySelectedIndex;
    for(var i=0; i<storeCollapseOpenArray.length; i++) 
    {
      if(storeCollapseOpenArray[i] == true)
      {
        currentlySelectedIndex = i;
      }
    }
    if(currentlySelectedIndex == index) {
      storeCollapseOpenArray[index] = false;
    }
    else 
    // If a different element was clicked, open the new one & close all others.
    {
      for(var i=0; i<storeCollapseOpenArray.length; i++) 
      {
        storeCollapseOpenArray[i] = false;
      }
      storeCollapseOpenArray[index] = true;
    }

    this.setState({
      storeCollapseOpenArray: storeCollapseOpenArray
    });
  }

  setMap = () => {
    let markers = [];
    this.state.storeLocations.map((store, index) => {
      var marker = new this.props.googleMapsObject.Marker({
        position: {lat: store.lat, lng: store.lng},
        title: store.name
      });
      markers.push(marker);
    });
    
    const mapOptions = {
      center: new this.props.googleMapsObject.LatLng(this.state.latitude, this.state.longitude),
      zoom: 7
    };
    const map = new this.props.googleMapsObject.Map(document.getElementById("map"), mapOptions);
    markers.map((marker, index) => {
      marker.setMap(map);
    });
  }

  toggleListButton = () => { this.setState({ listBtnSelected: true, mapBtnSelected: false }) }
  toggleMapButton = () => { this.setState({ mapBtnSelected: true, listBtnSelected: false }) }

  render () {
    const ListView = this.state.storeLocations.map((store, index) => {
      return <StoreDropdownContainer containerOpen={this.state.storeCollapseOpenArray[index]} key={index}>
        <Dropdown toggle={() => this.storeCollapseToggle(index)} >
          <DropdownToggle caret>
                  <h2>{index+1 + '. ' + store.name}</h2>
                  <h3>  
                    Distance: {' '} 
                    {
                      (this.state.distanceObjectArray.length == this.state.storeLocations.length 
                        && this.state.distanceObjectArray[index])
                        ?
                      this.state.distanceObjectArray[index].Distance
                      : 
                      "Unknown (enable location services.)" 
                    } mi.
                  </h3>
          </DropdownToggle>
        </Dropdown>
        <Collapse isOpen={this.state.storeCollapseOpenArray[index]}>
                  <p>{store.address + ' ' + store.city + ' ' + store.state + ', ' + store.zip}</p>
                  <p>{store.phone}</p>
        </Collapse>
       </StoreDropdownContainer>
    });

  	return (
        <Container_s>
         <Helmet>
            <title>Store Locator - Primitives Candles</title>
          </Helmet>

          <h2>Store Locator</h2>
          <h3>Find a store near you that sells our candles</h3>
          <hr />
          <ListOrMapBtnContainer>
            <LocatorBtn size="md" onClick={() => this.toggleListButton()} active={this.state.listBtnSelected}>List</LocatorBtn>
            <LocatorBtn size="md" onClick={() => this.toggleMapButton()} active={this.state.mapBtnSelected}>Map</LocatorBtn>
          </ListOrMapBtnContainer>

          <ListViewContainer listSelected={this.state.listBtnSelected}>
            {ListView} 
          </ListViewContainer>
    
          <MapViewContainer mapSelected={this.state.mapBtnSelected}>
            <MapInternalContainer>
               <div id="map" ></div>
             </MapInternalContainer>
          </MapViewContainer>

        </Container_s>
  	);
  }
}

const ListOrMapBtnContainer = styled(Container)``;
const StoreDropdownContainer = styled(({ containerOpen, ...rest }) => <Container {...rest} />)`
  margin-bottom: 10px;
  text-align: left;
  background-color: ${a => a.containerOpen ? "#BCA368" : "#c9b483"};

  .dropdown {
    background-color: ${a => a.containerOpen ? "#BCA368" : "#c9b483"};
    height: 110px;
    line-height: 110px;

    button {
      width: 100%;
      padding: 0;
      font-family: 'Handlee';
      background: none;
      border: none;
      vertical-align: middle;
        word-break: break-all;
        white-space: normal;

      h2 {
        margin: 0;
        font-size: 20px;
        ${media.lg` font-size: 22px; `}
        text-align: left;
        margin-bottom: 30px;
      }
      h3 {
        margin: 0;
        font-size: 15px;
        ${media.lg` font-size: 17px; `}
            ${media.xl` font-size: 19px; `}
        text-align: left;
      }

      ::after {
        float: right;
        margin-top: -9px;
          border-top-width: ${a => a.containerOpen ? 0 : ""};
          border-bottom: ${a => a.containerOpen ? "4.8px solid #000000" : ""};
      }

      :focus {
        box-shadow: none;
      }
    }
  }
  .collapse, .collapsing {
    background-color: ${a => a.containerOpen ? "#BCA368" : "#c9b483"};

    p {
      margin-bottom: 0px;
      font-size: 14px;
      ${media.lg` font-size: 16px; `}
      ${media.xl` font-size: 18px; `}
    }
  }
`;

const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  margin-top: 30px;
  padding: 0!important;
`;



const Container_s = styled(Container)`
  padding: 0!important;
  padding-top: 10px!important;

  h2,h3 {
    color: #76451F;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
    margin: 10px 15px 10px 15px;
    word-break: break-word;
  }
  h3 {
    color: black;
    font-size: 15px;
    margin-bottom: 20px;
    ${media.lg` font-size: 18px; `}

  }
  hr {
    border-top: 1.1px solid #8A572A;
  }
  listOrMapBtnContainer {
    display: block;
    text-align: right;
    margin-right: 20px;
  }

`;

const LocatorBtn = styled(({ active, ...rest }) => <Button {...rest} />)`
  margin-left: 10px;
  cursor: pointer;
  border: 0px!important;
  font-family: 'Raleway';
  font-size: 16px;
  font-weight: bold!important;
  width: 80px;
  height: 35px;

  ${media.lg` font-size: 20px!important; width: 100px; height: 45px; `}

  color: ${props => props.active ? "white!important" : "#76451F!important"};
  background-color: ${props => props.active ? "#8B572A!important" : "lightgray!important"};
`;

const MapViewContainer = styled(({ mapSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.mapSelected ? "block" : "none"}; // i changed from 'none' to 'block' here so it's always rendered 10/28/17
  margin-top: 30px;
  padding: 0!important;
  color: red;
  div {
    background-color: transparent;
  }
  
`;
const MapInternalContainer = styled(Container)`
  padding: 0!important;
  width: 100%;
  height: 600px;
  
  div#map {
    width: 95%;
    height: 100%;
    margin: 0 auto;
  }
`;


// WEBPACK FOOTER //
// ./src/pages/Locator.js